import React, { Component } from 'react';
import LoadMask from "../../../Utils/LoadMask/LoadMask";
import CardSimple from '../../../Utils/Cards/cardSimple';
import {RenderMoneda} from "../../../Utils/renderField/renderTableField";

// Manejo de tabs
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import moment from 'moment';

import ToolbarReporteAusencias from '../../../Utils/Toolbar/ToolbarReporteAusencias';
import { Redirect } from 'react-router';

import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import {standardActions} from '../../../Utils/Grid/StandardActions';



export default class PPlanillaporEmpleado extends Component {

    componentDidMount(){
        // this.props.getResumen();
        this.props.ListarPagosEmpleado(1)
    }

    render() {
        const { loader, resumen, permisos, page2, data2, ListarPagosEmpleado } = this.props;
        if(permisos.rep_pagoplanilla === false) {
            return <Redirect to={`/`} />
        }
        return (
            <CardSimple titulo="REPORTE DE PAGO DE PLANILLA POR EMPLEADO">
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <div className="col-md-12 row m-0 p-0 d-flex justify-content-md-end justify-content-center mt-0"
                        style={{border:"1px solid #E8E8E8", }}>
                        <div className="row col-12 m-0  inline-headers text-lg-left" style={{padding:"15px"}}>
                            <ToolbarReporteAusencias 
                                // {...this.props} 
                                changeEmpleado={this.props.changeEmpleadoPlanilla}
                                changeEmpresa={this.props.changeEmpresao3}
                                empleado={this.props.empleado}
                                empresa={this.props.empresa}
                                fecha_inicio={this.props.fecha_inicio}
                                fecha_fin={this.props.fecha_fin}
                                changeFechaInicio={this.props.changeFechaInicio1}
                                changeFechaFin={this.props.changeFechaFin1}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 row m-0 p-0 d-flex  justify-content-center mt-3"
                        style={{border:"1px solid #E8E8E8", }}>
                        <div className="col-12 d-flex justify-content-center" >
                            <div >
                                <br/>
                                <h3 className="t-musgo">TOTAL PAGADO</h3>
                                <h3 className="t-primary m-0 text-center">
                                    <RenderMoneda monto={ this.props.totalizados.total } simbolo={'Q. '} />
                                </h3>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div  style={{border:"1px solid #E8E8E8", }}>

                        <div className="col-md-12 row m-0 p-0 d-flex justify-content-md-end justify-content-center mt-3">
                            <div className="col-md-6 col-12 d-flex justify-content-center">
                                <div>
                                    <br/>
                                    <h4 className="t-musgo">{"TOTAL SUELDO"}</h4>
                                    <h4 className="t-mostaza m-0 text-center bold">
                                        <RenderMoneda monto={ this.props.totalizados.total_sueldo } simbolo={'Q. '} />
                                    </h4>
                                    <br/>
                                </div>
                            </div>
                            <div className="col-md-6 col-12  d-flex justify-content-center" >
                                <div>
                                    <br/>
                                    <h4 className="t-musgo">TOTAL BONOS</h4>
                                    <h4 className="t-mostaza m-0 text-center bold">
                                        <RenderMoneda monto={ this.props.totalizados.total_bonos } simbolo={'Q. '} />
                                    </h4>
                                    <br/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 row m-0 p-0 d-flex justify-content-md-center justify-content-center mt-3">
                            <div className="col-md-6 col-12 d-flex justify-content-center">
                                <div>
                                    <br/>
                                    <h4 className="t-musgo">{ "TOTAL ACTIVIDADES"}</h4>
                                    <h4 className="t-mostaza m-0 text-center bold">
                                        <RenderMoneda monto={ this.props.totalizados.total_actividades } simbolo={'Q. '} />
                                    </h4>
                                    <br/>
                                </div>
                            </div>
                            <div className="col-md-6 col-12  d-flex justify-content-center" >
                                <div>
                                    <br/>
                                    <h4 className="t-musgo">TOTAL DESCUENTOS</h4>
                                    <h4 className="t-mostaza m-0 text-center bold">
                                        <RenderMoneda monto={ this.props.totalizados.total_descuentos } simbolo={'Q. '} />
                                    </h4>
                                    <br/>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 d-flex justify-content-center">
                                <div>
                                    <br/>
                                    <h4 className="t-musgo">{ "TOTAL PRODUCCION"}</h4>
                                    <h4 className="t-mostaza m-0 text-center bold">
                                        <RenderMoneda monto={ this.props.totalizados.total_produccion } simbolo={'Q. '} />
                                    </h4>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3">
                        <Grid
                            hover
                            striped
                            data={data2}
                            loading={loader}
                            page={page2}
                            className="reporte-table"
                            onPageChange={ListarPagosEmpleado}
                        >
                            <TableHeaderColumn
                                isKey
                                dataField="id"
                                dataSort
                                className='reporte-table'
                                dataFormat={
                                    standardActions({ ver: "/detalle_planilla" })
                                }
                            />
                            <TableHeaderColumn
                                dataField="creado"
                                dataSort
                                className='reporte-table'
                                // width="14%"
                                dataFormat={(cell) => moment(cell).format('DD-MM-YYYY')}
                            >
                                FECHA
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="empleado"
                                dataSort
                                className='reporte-table'
                                // width="A%"
                                // dataFormat={(cell, row) => (<RenderMoneda monto={ cell } simbolo={'Q'} />)}
                            >
                                EMPLEADO
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="sueldo"
                                dataSort
                                className='reporte-table'
                                // width="A%"
                                dataFormat={(cell, row) => row.tipo_empleado == 5 ?   <RenderMoneda monto={ 0 } simbolo={'Q'} /> :<RenderMoneda monto={ cell } simbolo={'Q'} /> }
                            >
                                SUELDO
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="sueldo"
                                dataSort
                                className='reporte-table'
                                // width="A%"
                                dataFormat={(cell, row) => row.tipo_empleado == 5 ?  <RenderMoneda monto={ cell } simbolo={'Q'} /> : <RenderMoneda monto={ 0 } simbolo={'Q'} /> }
                            >
                                PRODUCCION
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="subtotal_actividades"
                                dataSort
                                className='reporte-table'
                                // width="20%"
                                dataAlign="right"
                                dataFormat={(cell, row) => (<RenderMoneda monto={ cell } simbolo={'Q'} />)}
                            >
                                ACTIVIDADES
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="subtotal_bonos"
                                dataSort
                                className='reporte-table'
                                // width="20%"
                                dataAlign="right"
                                dataFormat={(cell, row) => (<RenderMoneda monto={ cell } simbolo={'Q'} />)}
                            >
                                BONOS
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="descuento_sueldo"
                                dataSort
                                className='reporte-table'
                                // width="20%"
                                dataAlign="right"
                                dataFormat={(cell, row) => (<RenderMoneda monto={ cell } simbolo={'Q'} />)}
                            >
                                DESCUENTOS
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="total"
                                dataSort
                                className='reporte-table'
                                // width="20%"
                                dataAlign="right"
                                dataFormat={(cell, row) => (<RenderMoneda monto={ cell } simbolo={'Q'} />)}
                            >
                                TOTAL
                            </TableHeaderColumn>
                        </Grid>
                    </div>
                </LoadMask>

            </CardSimple>
        )

    }
}
